import React from 'react';

// Styles
import styles from "./Notification.module.css";

// Image
import arrowLeft from "./../../../assets/img/DashboardICons/ArrowLeftBlue.svg";


const NotificationBoxs = (props) => {

    return (
        <>
            <div className="py-2">
                <div className="container-fluid">
                    <div
                        className={`w-100 d-flex justify-content-center flex-wrap ${props.allNotif == "" ? "align-items-center" : "align-items-start"} mt-3 me-3`}
                        dir="rtl"
                        style={{ minHeight: "397px" }}
                    >
                        <div className='w-100 d-flex align-items-center justify-content-xl-between justify-content-center flex-wrap'>
                            {props.allNotif == "" ?
                                <div className={`w-100 d-flex align-items-center justify-content-center ${styles.text1}`}>
                                    اعلانی وجود ندارد
                                </div>
                                :
                                props.allNotif?.map((item) => (
                                    <div key={item.id} className={`d-flex align-items-center justify-content-center px-3 py-2 my-3 mx-xl-2 mx-lg-0 ${props.userSide ? styles.card_conatienr_user : styles.card_conatienr}`}>
                                        <div className="d-flex align-items-center justify-content-between w-100">
                                            <span className={styles.sender_notification}>
                                                {item.title}
                                            </span>
                                            <div className="me-auto ms-2 ps-1 pointer" onClick={() => props.setShowModal((prev) => {
                                                return { ...prev, openDetail: true, id: item.id };
                                            })}>
                                                <img src={arrowLeft} alt="arrow-left" />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotificationBoxs